import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { IClient, IClientCreate, IClientsSurvey } from '../../utils/Interfaces/client.interface'

const BASE_URL = import.meta.env.VITE_BASE_URL
const GET_LIST_URL = '/api/clients'

export const clientsApi = createApi({
  reducerPath: 'clientsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: 'include'
  }),
  tagTypes: ['Client'],
  endpoints: (build) => ({
    getClients: build.query<IClient[] | IClientsSurvey[], void | string>({
      query: (string) => ({
        url: `${GET_LIST_URL}${string ? `?${string}` : ''}`
      }),
      providesTags: ['Client']
    }),
    getCLient: build.query<IClient, string>({
      query: (id) => ({
        url: `${GET_LIST_URL}/${id}`
      }),
      providesTags: ['Client']
    }),
    addClient: build.mutation<IClient, IClientCreate | FormData>({
      query: (body) => ({
        url: GET_LIST_URL,
        method: 'POST',
        body
      }),
      invalidatesTags: ['Client']
    }),
    updateClient: build.mutation<IClient, { id: string, body: IClientCreate | FormData }>({
      query: ({ id, body }) => ({
        url: `${GET_LIST_URL}/${id}`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: ['Client']
    }),
  })
})

export const { useGetClientsQuery, useGetCLientQuery, useAddClientMutation, useUpdateClientMutation } = clientsApi
